import securels from "secure-ls";

// create an instance of securels
const ls = new securels({
  encodingType: "aes",
  encryptionSecret: process.env.VUE_APP_SLS_SECRET,
});

export default ls;
